module.exports = __webpack_public_path__ + "static/vib_play7s-41ad4e32ddf8ecf01f8c6d2dfad1759e.jpg";